var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品代码"),
      prop: "code"
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品代码")
    },
    model: {
      value: _vm.form.code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("产品名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称")
    },
    model: {
      value: _vm.form.name2.name,
      callback: function ($$v) {
        _vm.$set(_vm.form.name2, "name", $$v);
      },
      expression: "form.name2.name"
    }
  }), _c("div", {
    staticClass: "right"
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.name2.isEdit
    },
    on: {
      change: function ($event) {
        _vm.form.name2.isEdit = !_vm.form.name2.isEdit;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("客户自定义")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox2",
    attrs: {
      label: _vm.$t("备案号"),
      prop: "recordNumber"
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备案号")
    },
    model: {
      value: _vm.form.recordNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordNumber", $$v);
      },
      expression: "form.recordNumber"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备案名称"),
      prop: "recordName"
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备案名称")
    },
    model: {
      value: _vm.form.recordName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordName", $$v);
      },
      expression: "form.recordName"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)])], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("承保单位"),
      prop: "unitId"
    }
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保单位"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label",
      disabled: _vm.id != -1 ? true : false
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.form.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unitId", $$v);
      },
      expression: "form.unitId"
    }
  }, _vm._l(_vm.unitList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("承保机构"),
      prop: "agencyId"
    }
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保机构"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label",
      disabled: _vm.form.unitId && _vm.id == -1 ? false : true
    },
    on: {
      change: e => _vm.getReminder(e, "second")
    },
    model: {
      value: _vm.form.agencyId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "agencyId", $$v);
      },
      expression: "form.agencyId"
    }
  }, _vm._l(_vm.agencyList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("中介机构")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("中介机构"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label",
      disabled: _vm.id != -1 ? true : false
    },
    model: {
      value: _vm.form.intermediaryId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "intermediaryId", $$v);
      },
      expression: "form.intermediaryId"
    }
  }, _vm._l(_vm.intermediaryList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c("div", {
    staticClass: "right"
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("产品大类"),
      prop: "sortId"
    }
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品大类"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label",
      disabled: _vm.id != -1 ? true : false
    },
    model: {
      value: _vm.form.sortId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sortId", $$v);
      },
      expression: "form.sortId"
    }
  }, _vm._l(_vm.insuranceClassList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.insuranceSortId
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("承保区域"),
      prop: "underwriteArea"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("承保区域")
    },
    model: {
      value: _vm.form.underwriteArea,
      callback: function ($$v) {
        _vm.$set(_vm.form, "underwriteArea", $$v);
      },
      expression: "form.underwriteArea"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("生效日"),
      prop: "effective"
    }
  }, [_c("a-input-number", {
    staticClass: "cont",
    attrs: {
      min: 0,
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("输入限制：单值（N）")
    },
    model: {
      value: _vm.form.effective,
      callback: function ($$v) {
        _vm.$set(_vm.form, "effective", $$v);
      },
      expression: "form.effective"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("出单模式"),
      prop: "isTimely"
    }
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("出单模式"),
      disabled: _vm.id != -1 ? true : false
    },
    model: {
      value: _vm.form.isTimely,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isTimely", $$v);
      },
      expression: "form.isTimely"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("实时出单")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("非实时出单")) + " ")])], 1), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox2 radio-lh",
    attrs: {
      label: _vm.$t("自动续保"),
      prop: "isRenewal"
    }
  }, [_c("a-radio-group", {
    staticClass: "cont",
    model: {
      value: _vm.form.isRenewal,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isRenewal", $$v);
      },
      expression: "form.isRenewal"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("投保份数"),
      prop: "servings"
    }
  }, [_c("a-input-number", {
    staticClass: "cont",
    attrs: {
      precision: 0,
      min: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("输入限制：单值（N）")
    },
    model: {
      value: _vm.form.servings,
      callback: function ($$v) {
        _vm.$set(_vm.form, "servings", $$v);
      },
      expression: "form.servings"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("产品备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品备注")
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("基础价格"),
      prop: "price"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品基础价格")
    },
    on: {
      change: function ($event) {
        return _vm.dataFormChange("price");
      }
    },
    model: {
      value: _vm.form.price,
      callback: function ($$v) {
        _vm.$set(_vm.form, "price", $$v);
      },
      expression: "form.price"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: "保障对象",
      prop: "object"
    }
  }, [_c("a-radio-group", {
    staticClass: "cont",
    model: {
      value: _vm.form.object,
      callback: function ($$v) {
        _vm.$set(_vm.form, "object", $$v);
      },
      expression: "form.object"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v("个体")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v("团体")])], 1)], 1)], 1)], 1), _vm.form.agencyId ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保提醒")))])]) : _vm._e(), _vm.form.agencyId ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    ref: "reminderRef",
    staticClass: "contBox3",
    staticStyle: {
      position: "relative"
    },
    style: _vm.form.content ? "" : "margin-bottom: 50px",
    attrs: {
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 16
      },
      label: _vm.$t("投保提醒"),
      prop: "content"
    }
  }, [_c("div", {
    staticClass: "reminder",
    style: _vm.show ? "border:1px solid #f5222d" : "",
    domProps: {
      innerHTML: _vm._s(_vm.form.content)
    }
  }), _vm.show ? _c("div", {
    staticStyle: {
      position: "absolute",
      bottom: "-50px",
      left: "0px",
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("当前保险机构暂未无投保提醒,请前往")) + "“"), _c("span", {
    staticStyle: {
      color: "#1890ff"
    }
  }, [_vm._v(_vm._s(_vm.$t("机构管理")))]), _vm._v("”" + _vm._s(_vm.$t("配置")) + " ")]) : _vm._e()])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox2",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      label: _vm.$t("回显名称"),
      prop: "echoName"
    }
  }, [_c("a-radio-group", {
    staticClass: "cont",
    attrs: {
      disabled: !_vm.form.content
    },
    on: {
      change: _vm.changeRadio
    },
    model: {
      value: _vm.form.echoName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "echoName", $$v);
      },
      expression: "form.echoName"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "VARIABLE_TYPE"
    }
  }, [_vm._v(_vm._s(_vm.$t("变量类型")))]), _c("a-radio", {
    attrs: {
      value: "UPLOAD_FILE"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传文件名称")))])], 1)], 1)], 1)], 1) : _vm._e()], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      margin: "20px 0"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };